export default () => {
	const popup = document.querySelector(`.popup[data-popup="bis"]`);
	const popupWrapper = popup.closest('.popup-wrapper');
	const popupWindow = popup.querySelector('.popup__window');
	const backInStockBlocks = document.querySelectorAll('.js-bis');


	document.addEventListener('click', (e) => {
		if (e.target.closest('.js-open-notify')) {
			e.preventDefault();
			if (popup) {
				popupWrapper.classList.add('popup-wrapper--visible');
				popup.classList.add('popup--visible');
				popupWindow.classList.add('popup__window--visible');
			}

			const sizeSwatch = e.target.closest('.size-select__item ');

			if (sizeSwatch) {
				backInStockBlocks.forEach(function(block) {
					const form = block.querySelector('form');

					if (form) {
						form.dataset.variantId = sizeSwatch.dataset.id;
						form.dataset.productId = sizeSwatch.dataset.productId;
					}
				});
			}
		}
	});


	backInStockBlocks.forEach(function(bis) {
		const form = bis.querySelector('.js-bis-form');
		const input = bis.querySelector('.js-bis-input');
		const marketing = bis.querySelector('.js-bis-input-marketing');

		const success = bis.querySelector('.bis__text--thank');
		const error = bis.querySelector('.bis__text--error');

		if (form && input) {
			form.addEventListener('submit', (e) => {
				e.preventDefault();

				bis.classList.remove('bis--error');

				const email = input.value;
				const pid = +form.dataset.productId;
				const vid = +form.dataset.variantId;
				const attributes = {};
				if (marketing.checked) attributes.accepts_marketing = true;

				if (email && pid && vid) {
					BIS.create(email, vid, pid, attributes).then(function(resp) {
						if (resp.status == 'OK') {
							success.innerText = resp.message;
							bis.classList.add('bis--success');
						} else {
							error.innerText = resp.errors.base;
							bis.classList.add('bis--error');
						}
					});
				}
			});
		}
	});
};
